// @ts-nocheck
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface Props {
    eventSummary: string;
    lightText?: boolean;
    extendedStyles?: EventDescriptionStyles;
}

export interface EventDescriptionStyles {
    textSummary?: TypographyPresentationProps;
}

export const eventDescriptionStyles: EventDescriptionStyles = {
    textSummary: {
        css: css`
            margin-bottom: ${pxToRem(15)};
        `,
    },
};

const EventDescription = ({ eventSummary, lightText, extendedStyles }: Props) => {
    const styles = useMergeProps(eventDescriptionStyles, extendedStyles);

    return (
        <Typography {...styles.textSummary} color={lightText ? "white" : "text"}>
            {eventSummary}
        </Typography>
    );
};

export default EventDescription;
